module.exports = __webpack_public_path__ + "img/pruning.03a120f7.jpg";